<template>
    <div class="main-nav grid" :class="rootClasses">
        <!-- <div style="position: fixed; left: 0; top: 0; background: white; width: 100%; z-index: 10000" v-text="boundaries"></div> -->

        <transition-group name="trs-main-nav-switch" tag="div" class="main-nav--animation-root">
            <div key="fixed" v-if="isCompact" class="main-nav--wrap main-nav--wrap__fixed" :style="scrollLockStyles">
                <div class="main-nav--wrapper grid--container">
                    <cmp-main-nav-items-partial :logo-url="'img/sib_logo.svg' | static"
                            facet="fixed"
                            :is-fixed="true"
                            :structure="structure">
                    </cmp-main-nav-items-partial>
                </div>
            </div>
            <div key="base" v-else class="main-nav--wrap main-nav--wrap__base">
                <div class="main-nav--wrapper grid--container">
                    <cmp-main-nav-items-partial :logo-url="'img/sib_logo_claim.svg' | static"
                            facet="base"
                            :structure="structure">
                    </cmp-main-nav-items-partial>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import bemMixin from 'vue/mixins/bem';
    import navItemMixin from 'vue/mixins/nav-item';
    import scrollLockHelperMixin from 'vue/mixins/scroll-lock-helper';
    import viewportBoundariesMixin from 'vue/mixins/viewport-boundaries';


    export default {
        mixins: [
            bemMixin('main-nav'),
            navItemMixin,
            scrollLockHelperMixin,
            viewportBoundariesMixin,
        ],
        props: {
            structure: Array,
        },
        computed: {
            ...mapGetters(['navTheme']),
            rootClasses() {
                return [
                    this.bemIf(this.isCompact, 'is-compact'),
                    this.bemAdd(this.navTheme),
                ];
            },
            isCompact() {
                return this.boundaries.el.bottom.isBefore.vp.top;
            },
        },
        methods: {
            ...mapActions(['resetNavigation']),
        },
        watch: {
            isCompact: {
                handler() {
                    this.resetNavigation();
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?38b0dac4